<body>
  <div class="card-container">
    <su-card [card]="cardSupport">
      <div card-content>
        <p [innerHTML]="'support.itSupportContent' | translate"></p>
        <p [innerHTML]="'support.externalItSupportContent' | translate"></p>
      </div>
    </su-card>
  </div>
</body>
